module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/zh-hans-card-drag.6f1c6dc8b7e5df6e2c10.gif";